/**
 * Token Validity Type Enum
 *
 * Defines how token expiry is calculated:
 *
 * Static types (computed at issuance from template):
 * - FIXED_DATE: Uses expiryDate directly as absolute expiration
 * - DAYS_FROM_ISSUANCE: Computes expiry as issuance date + validityDuration days
 * - HOURS_FROM_ISSUANCE: Computes expiry as issuance date + validityDuration hours
 * - MONTHS_FROM_ISSUANCE: Computes expiry as issuance date + validityDuration months
 * - END_OF_MONTH: Token expires at end of the month when issued
 * - END_OF_YEAR: Token expires at end of the year when issued
 *
 * Trigger-based types (computed from runtime context):
 * - TRIGGER_DATE: Uses date from context.validityDate (e.g., hotel check-out date)
 * - TRIGGER_DATE_RANGE: Uses context.validityEndDate directly (for explicit start/end scenarios)
 * - DAYS_FROM_TRIGGER: Computes expiry as context.validityDate + duration days
 *                      Duration from context.validityDuration OR template.validityDuration
 * - HOURS_FROM_TRIGGER: Same as above but hours
 */
export const TokenValidityTypes = {
    FIXED_DATE: 'fixed_date',
    DAYS_FROM_ISSUANCE: 'days_from_issuance',
    HOURS_FROM_ISSUANCE: 'hours_from_issuance',
    MONTHS_FROM_ISSUANCE: 'months_from_issuance',
    END_OF_MONTH: 'end_of_month',
    END_OF_YEAR: 'end_of_year',
    // Trigger-based types - require context at runtime
    TRIGGER_DATE: 'trigger_date',
    TRIGGER_DATE_RANGE: 'trigger_date_range',
    DAYS_FROM_TRIGGER: 'days_from_trigger',
    HOURS_FROM_TRIGGER: 'hours_from_trigger',
};
export const TOKEN_VALIDITY_TYPE_VALUES = Object.values(TokenValidityTypes);
//# sourceMappingURL=token-validity-type.enum.js.map